import { formatDate } from '@packages/utils';

function datetimeFormatter({ value }: { value: Date }) {
  return value != null ? formatDate(value) : '-';
}

export default datetimeFormatter;
